export default{

    methods: {

        onQueryError(error) {

            const logger = this.logger || this.$di.logger;

            logger.error('Query error', error);
            this.$toast.error('De gegevens konden niet worden opgehaald');

            this.$router.replace({ name: this.$di.config.homeRoute });
        }
    }
};
